import { fetchEventsByZipcode } from 'api';
import { isValidZipcode } from 'utils/zipcode';
import {
  selectZipcode,
  selectRadius,
  selectIsZipcodeValid,
} from './selectors';
import { clearSelection, updateSource } from '../map';
import { getEvents } from '../geojson';
import {
  UPDATE_ZIPCODE,
  UPDATE_RADIUS,
  SET_ERROR_MESSAGE,
  SEARCH,
  SET_SEARCH_ACTIVE,
} from './types';

export const setErrorMessage = message => ({
  type: SET_ERROR_MESSAGE,
  payload: message,
});

export const updateZipcode = value => async dispatch => {
  const isValid = isValidZipcode(value);
  dispatch({
    type: UPDATE_ZIPCODE,
    payload: { value, isValid },
  });
};

export const updateRadius = option => (dispatch, getState) => {
  const radii = selectRadius(getState());
  if (radii === option) return;
  dispatch({
    type: UPDATE_RADIUS,
    payload: option,
  });
};

export const search = () => (dispatch, getState) => {
  const state = getState();

  const isZipcodeValid = selectIsZipcodeValid(state);
  if (!isZipcodeValid) {
    return dispatch(setErrorMessage('Please enter a valid zipcode'));
  }

  const zipcode = selectZipcode(state);
  const radius = selectRadius(state);

  return dispatch({
    type: SEARCH,
    promise: fetchEventsByZipcode(zipcode, radius),
    meta: {
      onSuccess: () => {
        dispatch(clearSelection());
        dispatch(updateSource());
      },
    },
  });
};

export const setSearchActive = isActive => ({
  type: SET_SEARCH_ACTIVE,
  payload: isActive,
});

export const clearSearch = () => dispatch => {
  dispatch(updateZipcode(''));
  dispatch(setSearchActive(false));
  dispatch(getEvents());
};
